import React from 'react';
import {
  HelpCircle,
  Activity, AlertTriangle, ArrowLeft, ChevronDown, ChevronRight, ClipboardList, Clock, FileCheck2, Home,
  LogOut, Menu, Plus, Spline, Trash2, TreeDeciduous, User, UserX, Users, X,
} from 'lucide-react';

// Mapa explícito de iconos usados por <Icon name="X" /> en esta app.
// Importar lucide-react con `import *` desactiva el tree-shake y arrastra los
// ~1000 iconos (>700KB). Aquí solo listamos los que de verdad usamos.
const ICONS = {
  Activity, AlertTriangle, ArrowLeft, ChevronDown, ChevronRight, ClipboardList, Clock, FileCheck2, Home,
  LogOut, Menu, Plus, Spline, Trash2, TreeDeciduous, User, UserX, Users, X,
};

function Icon({ name, size = 24, color = 'currentColor', className = '', strokeWidth = 2, ...props }) {
  const IconComponent = ICONS[name];
  if (!IconComponent) {
    return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
  }
  return <IconComponent size={size} color={color} strokeWidth={strokeWidth} className={className} {...props} />;
}

export default Icon;
